module.exports = __webpack_public_path__ + "static/img/5.43438f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/5.jpg
// module id = dosO
// module chunks = 1